import {HttpClient, HttpHeaders} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import { ENVIRONMENT } from '@company-box/models';

@Injectable({
  providedIn: "root",
})
export class DesignService {
  private httpClient: HttpClient = inject(HttpClient);
  constructor() {}
  private environment = inject(ENVIRONMENT);
  
  getPatternCollections(): Promise<any> {
    const url = `${this.environment.apiHost}/project/builder/pattern/collection/list?published=PUBLISHED`;

    return new Promise<any>((resolve, reject) => {
      this.httpClient.get(url).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error.message || error);
        }
      );
    });
  }

  getPatterns(collectionId: number, offset: number = 0, limit: number = 50): Promise<any> {
    const url = `${this.environment.apiHost}/project/builder/pattern/list?collection=${collectionId}&limit=${limit}&offset=${offset}&published=PUBLISHED`;

    return new Promise<any>((resolve, reject) => {
      this.httpClient.get(url).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error.message || error);
        }
      );
    });
  }

  getShapeCollections(): Promise<any> {
    const url = `${this.environment.apiHost}/project/builder/shape/collection/list?published=PUBLISHED`;

    return new Promise<any>((resolve, reject) => {
      this.httpClient.get(url).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error.message || error);
        }
      );
    });
  }

  getShapes(collectionId: number, offset: number = 0, limit: number = 50): Promise<any> {
    const url = `${this.environment.apiHost}/project/builder/shape/list?collection=${collectionId}&limit=${limit}&offset=${offset}&published=PUBLISHED`;

    return new Promise<any>((resolve, reject) => {
      this.httpClient.get(url).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error.message || error);
        }
      );
    });
  }

  getDesign(userID: number, containerID: string): Promise<any> {
    const url = `${this.environment.apiHost}/project/design/${userID}/container/${containerID}`;

    return new Promise<any>((resolve, reject) => {
      this.httpClient.get(url).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  createDesign(userID: number, design: any): Promise<any> {
    const url = `${this.environment.apiHost}/project/design/${userID}/`;

    const payload = JSON.stringify(design);

    const headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return new Promise<any>((resolve, reject) => {
      this.httpClient.post(url, payload, headers).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  updateDesign(userID: number, design: any): Promise<any> {
    const url = `${this.environment.apiHost}/project/design/${userID}/`;

    const payload = JSON.stringify(design);

    const headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return new Promise<any>((resolve, reject) => {
      this.httpClient.put(url, payload, headers).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  deleteDesign(userId: number, designId: number): Promise<any> {
    const url = `${this.environment.apiHost}/project/design/${userId}/${designId}`;

    return new Promise<any>((resolve, reject) => {
      this.httpClient.delete(url).subscribe(
        (res) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
}
